import BlueBox from "./BlueBox";

export default BlueBox;
